import {
  MotifButton,
  MotifFormField,
  MotifIcon,
  MotifInlineMessage,
  MotifInput,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader
} from '@ey-xd/motif-react';
import React, { useCallback, useEffect, useState } from 'react';
import iconSvg from '../../assets/icons/icon.svg.json';
import { useDispatch, useSelector } from 'react-redux';

const TemplatePromptInput = (props: any) => {
  const { uniqueReportCacheId, engagementId, currentPage } = props;
  const [message, setMessage] = useState('');
  const [error, setError] = useState<any>();
  const [inputDisabled, setInputDisabled] = useState(false);
  const { access } = useSelector((state: any) => state.user);
  const [confirmEnabled, setConfirmEnabled] = useState(false);

  const dispatch = useDispatch();
  const onChange = (e: any) => {
    setMessage(e.target.value);
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSubmit();
    }
  };
  const onSubmit = () => {
    if (message === '') {
      setError('Please enter a message');
      return;
    }
    setError(undefined);
    toggleConfirmEnabled()
  };

  const toggleConfirmEnabled = () => {
    setConfirmEnabled(!confirmEnabled);
  };

  const confirmSubmit = () => {
    toggleConfirmEnabled();
    dispatch({
      type: 'GET_AI_RECOMMENDED_CONTENT_FOR_SLIDE_IN_REPORT',
      payload: {
        userPrompt: message,
        currentPage: `${currentPage}`,
        uniqueReportCacheId,
        engagementId: `${engagementId}`
      }
    });
    setMessage('');
  };

  const renderDialog = useCallback(() => {
    if(!confirmEnabled) {
        return <></>
    }
    return (
      <MotifModal onClose={() => {}} show={true}>
        <MotifModalHeader>
          <h5>Confirm</h5>
        </MotifModalHeader>
        <MotifModalBody>
          <div className="flex flex-col gap-3">
            <h5>You can update the status:</h5>
          </div>
        </MotifModalBody>
        <MotifModalFooter style={{ borderTop: '1px solid #ffffff26' }} className="!pb-0">
          <div className="flex gap-3 justify-end items-center my-4">
            <MotifButton onClick={toggleConfirmEnabled} size="medium" type="button" variant="secondary">
              Cancel
            </MotifButton>
            <MotifButton className="!mt-0" onClick={confirmSubmit} size="medium" type="button">
              Proceed
            </MotifButton>
          </div>
        </MotifModalFooter>
      </MotifModal>
    );
  }, [confirmEnabled]);

  return (
    <>
      <div className="flex gap-5">
        <div style={{ width: 'calc(100% - 2rem)' }}>
          <MotifFormField aria-label="Input" role="group">
            <MotifInput
              disabled={inputDisabled}
              aria-label="Input"
              ariaLabel="Input"
              id="input"
              label="Input"
              value={message}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              placeholder="Type in here..."
              className="!rounded-md"
            />
          </MotifFormField>
          {error && <MotifInlineMessage variant="error">{error}</MotifInlineMessage>}
        </div>
        <MotifButton
          disabled={inputDisabled}
          onClick={onSubmit}
          variant="primary"
          size="small"
          className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
        >
          <MotifIcon src={iconSvg['send-message']} className="w-5" title="Harrow-right" />
        </MotifButton>
      </div>
      {renderDialog()}
    </>
  );
};

export default TemplatePromptInput;
